module.exports = __webpack_public_path__ + "static/media/GoogleMap-2880w.2587dca4.webp";